import React from 'react';
import { useIntl } from '@kyruus/intl';
import { Box } from '@biome-design-system/ui/Box';
import { Typography } from '@biome-design-system/ui/Typography';
import { Link } from '@biome-design-system/ui/Link';
import type { Log } from 'Src/types';
import { sanitizeHref } from 'Src/utils/sanitizeHref';
import { messages } from '../messages';

interface NeedHelpSectionProps {
  needHelpPhoneNumber: string;
  log: Log;
}

export const NeedHelpSection = ({
  needHelpPhoneNumber,
  log
}: NeedHelpSectionProps) => {
  const intl = useIntl();
  const businessHoursMessage = intl
    .formatMessage(messages.needHelpHours)
    .trim();
  const onClick = () => {
    log('user_action.no_results.need_help_phone_number_clicked');
  };
  return (
    <Box component="section">
      <Typography
        variant="body1"
        component="h2"
        sx={(theme) => ({
          fontWeight: theme.typography.fontWeightBold,
          marginBottom: theme.spacing(1)
        })}
      >
        {intl.formatMessage(messages.needHelpHeading)}
      </Typography>
      <Typography
        variant="body1"
        sx={(theme) => ({
          color: theme.palette.grey[700],
          marginBottom: theme.spacing(2)
        })}
      >
        {intl.formatMessage(messages.needHelpDescription)}
      </Typography>
      <Link
        href={sanitizeHref(`tel:${needHelpPhoneNumber}`)}
        variant="h4"
        sx={(theme) => ({
          textDecoration: 'underline',
          color: theme.palette.text.primary,
          marginBottom: theme.spacing(0.5)
        })}
        onClick={onClick}
      >
        {intl.formatMessage(messages.needHelpPhoneNumber, {
          phoneNumber: needHelpPhoneNumber
        })}
      </Link>
      {businessHoursMessage && (
        <Typography
          data-testid="business-hours-message"
          variant="body1"
          sx={(theme) => ({ color: theme.palette.grey[700] })}
        >
          {businessHoursMessage}
        </Typography>
      )}
    </Box>
  );
};
